import { Popup } from '../../../components/Popup'
import { Typography } from '../../../components/Typography'
import { Button, BUTTON_TYPES } from '../../../components/Button'
import { BTN_TXT } from '../../../constants'

export const ConfirmChangesModal = ({ handleSubmit, close, visible }) => {
  return (
    <Popup
      title="Save changes to vendor organization?"
      visible={visible}
      onCancel={close}
      width={442}
      footer={
        <>
          {' '}
          <Button type={BUTTON_TYPES.DEFAULT} onClick={close} upperCase>
            {BTN_TXT.CANCEL}
          </Button>
          <Button
            onClick={() => {
              handleSubmit()
              close()
            }}
            type={BUTTON_TYPES.PRIMARY}
            upperCase
          >
            {BTN_TXT.UPDATE}
          </Button>
        </>
      }
    >
      <Typography.Body1>please confirm changes.</Typography.Body1>
    </Popup>
  )
}
